module.exports = __webpack_public_path__ + "img/certImg2.0828056b.png";